

























































import Vue from 'vue';
import { mapActions } from 'vuex';
import { BAlert } from 'bootstrap-vue';
import ZenButton from '@reciprocity/button';
import { omitDeep } from '../../../utils/utils';
import GenericCard from '@/components/cards/GenericCard.vue';
import LoadingState from '@/components/cards/loading_state/LoadingState.vue';
import { Alert } from '@/components/global_alerts/types';
import { ModalSize } from '@/components/zen_modal/types';
import RiskCardText from './components/RiskCardText.vue';
import RiskCardNumber from './components/RiskCardNumber.vue';
import RiskAddOrRemoveItems from '@/components/cards/risk_settings/components/RiskAddOrRemoveItems.vue';
import RiskCalculationBuilder from '@/components/cards/risk_settings/RiskCalculationBuilder/RiskCalculationBuilder.vue';
import { validate } from './RiskCardValidations';
import { RiskCardComponentType } from './types';
import { RiskAddEditMode } from '@/pages/risk_settings/types';

export default Vue.extend({
  name: 'RiskAddEditCard',
  components: {
    BAlert,
    GenericCard,
    ZenButton,
    LoadingState,
    RiskCardText,
    RiskCardNumber,
    RiskAddOrRemoveItems,
    RiskCalculationBuilder,
  },
  props: {
    dataUrl: {
      type: String,
      required: false,
      default: '',
    },
    valuesUrl: {
      type: String,
      required: false,
      default: '',
    },
    title: {
      type: String,
      required: true,
      default: '',
    },
    saveUrl: {
      type: String,
      required: false,
      default: '',
    },
    mode: {
      type: Number,
      required: false,
      default: RiskAddEditMode.Add,
    },
    fields: {
      type: Array,
      default: () => [],
    },
    modalSize: {
      type: String,
      default: 'Small',
    },
    successMessage: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: <boolean>false,
      saving: <boolean>false,
      alerts: <Alert[]>[],
      data: <any>{},
      formData: {},
      fieldsKey: <number>0,
    };
  },
  computed: {
    isInAddMode() {
      return this.mode === RiskAddEditMode.Add;
    },
  },
  async created() {
    this.loading = true;
    this.changeModalSize(ModalSize[this.modalSize]);
    this.resetData();

    if (this.dataUrl) {
      await this.fetchData();
    }
    if (this.valuesUrl) {
      await this.fetchValues();
    }
    this.loading = false;
  },
  methods: {
    ...mapActions({
      changeModalSize: 'modals/changeSize',
      cancelModal: 'modals/cancel',
      confirmModal: 'modals/confirm',
      showAlert: 'alerts/show',
      request: 'request',
    }),
    getComponent(fieldType: string) {
      return RiskCardComponentType[fieldType];
    },
    updateFormData(fieldName: string, value: any) {
      this.$set(this.formData, fieldName, value);
    },
    async fetchData() {
      try {
        this.data = await this.request({
          url: this.dataUrl,
          defaultErrorHandler: false,
        });
      } catch (errors) {
        this.alerts = [errors.response.data];
      }
    },
    async fetchValues() {
      try {
        let response = await this.request({
          url: this.valuesUrl,
          defaultErrorHandler: false,
        });

        if (this.mode === RiskAddEditMode.Duplicate) {
          omitDeep(response, 'id');
        }

        this.assignValues(response);
      } catch (errors) {
        this.alerts = [errors.response.data];
      }
    },
    assignValues(values: any): void {
      this.fields.forEach(field => {
        field.value = values[field.fieldName] || field.value;
        this.updateFormData(field.fieldName, values[field.fieldName] || field.value);
      });
      this.rerenderComponents();
    },
    isDataValid(): boolean {
      const errors: Alert[] = [];
      this.fields.forEach(field => {
        const validationErrors = validate(field.fieldType, this.formData[field.fieldName] || '', field.labels);
        errors.push(...validationErrors);
      });
      this.alerts = errors;
      return !errors.length;
    },
    async save(addAnother: boolean) {
      if (!this.isDataValid()) {
        return;
      }
      this.saving = true;
      try {
        await this.request({
          method: this.mode === RiskAddEditMode.Edit ? 'put' : 'post',
          url: this.saveUrl,
          data: this.formData,
          defaultErrorHandler: false,
        });
        this.showAlert({
          type: 'success',
          message: this.successMessage,
        });
        if (addAnother) {
          this.resetData();
          if (this.dataUrl) {
            this.fetchData();
          }
        } else {
          this.confirmModal();
        }
      } catch (errors) {
        this.alerts = [errors.response.data];
      } finally {
        this.saving = false;
      }
    },
    resetData() {
      this.formData = {};
      omitDeep(this.fields, 'value');
      this.rerenderComponents();
    },
    rerenderComponents() {
      this.fieldsKey++;
    },
  },
});
